import styled from 'styled-components'

export const Border = styled.div`
  p {
    border: ${props => (props.color ? `solid ${props.color}` : 'solid rgba(214, 214, 214, 0.3)')};
    border-width: ${props => (props.width ? props.width : '1px')};
    margin-bottom: 0;
  }
`
